import React, { Component } from 'react';
import { Icon, Popup, Accordion, Dimmer, Loader } from 'semantic-ui-react';
import DualForgeViewer from './components/dualForgeViewer';
import UploadSTL from './components/uploadSTL';
import FilesUpload from './components/filesUpload';
import SemanticCards from './components/semanticCards';
import WebSocketClient from './lib/WebSocketClient';
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";
import { Pie } from 'react-chartjs-2';
import AWS from 'aws-sdk';
import { Provider } from "react-redux";
import store from "./store";
import { actionApp_setWindowSize } from './actions'

import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share';

import { Menu } from 'semantic-ui-react'
import styles from './App.module.css'
import AppHeader from './components/header'

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isStartingForgeViewer: false,
      isDualForgeViewerStarted: false,
      isGeomColorsAvailable: false,
      isCreateNew: false,
      isSharedLink: true,
      showStatistics: true,
      isDownloadDimmer: false,
      geomColors: null,
      uploadData: {
        file: null,
        filename: '',
        urn1: '',
        urn2: ''
      },
      statdata: {
        labels: ['Cone', 'Cylinder', 'Plane', 'Sphere', 'Torus', 'BSpline'],
        datasets: [{
          data: [],
          backgroundColor: ['#55FFFF', '#FFFF7F', '#55AAFF', '#FFAA00', '#FF55FF', '#FF0000'],
          hoverBackgroundColor: ['#55FFFF', '#FFFF7F', '#55AAFF', '#FFAA00', '#FF55FF', '#FF0000']
        }]
      },

      statOptions: {
        legend: {
          display: false,
          labels: { generateLabels: (chart) => { return this.generateLabels(chart) } }
        }
      },
      visible: false
    };

    this.colorsArray = ['ConeColor', 'CylinderColor', 'PlaneColor', 'SphereColor', 'TorusColor', 'BSplineColor']
    this.elementTobeRendered = null
    this.firstViewer = null

    // this.appLogo = require('./images/CCTech_Logo.png')

    AWS.config.update({
      region: 'us-west-2',
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: 'us-west-2:9c66f931-8c9f-4425-b76f-59fc0d5fd2fb'
      })
    });

    this.ml_work_bucket = 'cctech-ml-work';
    this.ml_work_s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      params: { Bucket: this.ml_work_bucket }
    });

    window.addEventListener('resize', () => this.handleResize())
  }

  handleResize() {
    store.dispatch(actionApp_setWindowSize({ width: window.innerWidth, height: window.innerHeight }))
  }

  generateLabels(chart) {
    // console.log('chart : ', chart)
    let data = chart.data;
    let sum = 0;
    if (data.datasets.length) {
      data.labels.map(function (label, i) {
        let ds = data.datasets[0];
        sum = sum + ds.data[i]
        return {}
      })
    }
    if (data.labels.length && data.datasets.length) {
      return data.labels.map(function (label, i) {
        let meta = chart.getDatasetMeta(0);
        let ds = data.datasets[0];
        // let arc = meta.data[i];
        // let custom = arc && arc.custom || {};
        return {
          // And finally : 
          text: (ds.data[i] * 100 / sum).toFixed(2) + "% " + label,
          fillStyle: ds.backgroundColor[i],
          hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
          index: i
        };
      });
    }
    return [];
  }

  onWebSocketOpen() {
    this.setState({
      wsConnected: true
    })
  }

  componentDidMount() {
    WebSocketClient.init(this.onWebSocketOpen.bind(this));
  }

  componentWillUnmount() {
    // console.log("app will unmount !!")
    this.setState({
      isStartingForgeViewer: false,
      isDualForgeViewerStarted: false,
      isCreateNew: false,
      isSharedLink: true,
      showStatistics: true,
      uploadData: {
        file: null,
        filename: '',
        urn1: '',
        urn2: ''
      },
      statdata: {
        labels: ['Cone', 'Cylinder', 'Plane', 'Sphere', 'Torus', 'BSpline'],
        datasets: [{
          data: [],
          backgroundColor: ['#55FFFF', '#FFFF7F', '#55AAFF', '#FFAA00', '#FF55FF', '#FF0000'],
          hoverBackgroundColor: ['#55FFFF', '#FFFF7F', '#55AAFF', '#FFAA00', '#FF55FF', '#FF0000']
        }]
      },

      statOptions: {
        legend: {
          display: false,
          labels: { generateLabels: (chart) => { return this.generateLabels(chart) } }
        }
      },
      visible: false,
      wsConnected: false
    })

    this.elementTobeRendered = null
  }

  handleSegmentation(fileData, history) {
    // console.log('handleSegmentation the click !!!!!!!', fileData)
    this.setState({
      isStartingForgeViewer: true,
      isCreateNew: true,
      isSharedLink: false,
      uploadData: {
        file: fileData,
        filename: fileData.name
      }
    })

  }

  handleStartupSelection(responce) {
    // console.log("at handleStartupSelection @@@@@@@", responce)
    if (responce.name === 'Create New') {
      if (this) {
        this.setState({
          isCreateNew: true
        })
      }
    }
  }

  updateViewerState() {
    if (!this.state.isStartingForgeViewer) {
      this.setState({
        isStartingForgeViewer: true,
      })
    }
  }

  updateCreateNewState() {
    this.elementTobeRendered = null
    this.firstViewer = null

    this.setState({
      isCreateNew: true,
      isStartingForgeViewer: false,
      isDualForgeViewerStarted: false,
      visible: false
    })
  }

  changeHomePageState() {
    // console.log("goToStartupPage")
    this.setState({
      isStartingForgeViewer: false,
      isDualForgeViewerStarted: false,
      isCreateNew: false,
      isSharedLink: false,
      showStatistics: true,
      uploadData: {
        file: null,
        filename: '',
        urn1: '',
        urn2: ''
      },
      statdata: {
        labels: ['Cone', 'Cylinder', 'Plane', 'Sphere', 'Torus', 'BSpline'],
        datasets: [{
          data: [],
          backgroundColor: ['#55FFFF', '#FFFF7F', '#55AAFF', '#FFAA00', '#FF55FF', '#FF0000'],
          hoverBackgroundColor: ['#55FFFF', '#FFFF7F', '#55AAFF', '#FFAA00', '#FF55FF', '#FF0000']
        }]
      },

      statOptions: {
        legend: {
          display: false,
          labels: { generateLabels: (chart) => { return this.generateLabels(chart) } }
        }
      },
      visible: false
    })

    this.elementTobeRendered = null
    this.firstViewer = null
  }

  OnFirstViewerLoaded(viewer) {
    this.firstViewer = viewer
    this.wireframeShowOrHide()
  }

  OnDualViewerLoaded(uid) {
    // this.wireframeShowOrHide()
    var fileKey = 'ml-mesh-segmentation/stl-upload/' + uid + '/Results/Colored_Results/ClassificationStats.json';
    // console.log("fileKey : ", fileKey)

    this.ml_work_s3.getObject({
      Bucket: this.ml_work_bucket,
      Key: fileKey
    }, (err, data) => {
      if (err) console.log(err, err.stack);
      else console.log('ClassificationStats.json : ', data);

      if (data) {
        let file_content = data.Body.toString()
        // console.log("file_content : ", file_content)
        let json = JSON.parse(file_content)
        // console.log('Json file_content : ', json)
        let newData = []
        newData.push(json.Surface.cone)
        newData.push(json.Surface.cylinder)
        newData.push(json.Surface.plane)
        newData.push(json.Surface.sphere)
        newData.push(json.Surface.torus)
        newData.push(json.Surface.bSpline)

        let statdata = this.state.statdata
        statdata.datasets[0].data = newData

        if (this.state.isStartingForgeViewer) {
          this.setState({
            statdata: statdata,
            isDualForgeViewerStarted: true
          })
        }
        else {
          this.setState({
            isDualForgeViewerStarted: false
          })
        }
      }
    });

    this.ml_work_s3.getObject({
      Bucket: this.ml_work_bucket,
      Key: 'ml-mesh-segmentation/GeomColors.json'
    }, (err, data) => {
      if (err) console.log(err, err.stack);

      if (data) {
        let geomColors = JSON.parse(data.Body)
        let colors = []
        for (let index = 0; index < this.colorsArray.length; index++) {
          colors.push(geomColors[this.colorsArray[index]].hexColor)
        }

        let statdata = this.state.statdata
        statdata.datasets[0].backgroundColor = colors
        statdata.datasets[0].hoverBackgroundColor = colors

        this.setState((state, props) => ({
          geomColors: colors,
          isGeomColorsAvailable: true,
          statdata: statdata
        }))
      }
    });
  }

  wireframeShowOrHide() {
    if (this.firstViewer) {
      let ext = this.firstViewer.getExtension('Autodesk.Viewing.Wireframes')
      if (!ext) {
        // console.log('extention not loaded')
        this.firstViewer.loadExtension('Autodesk.Viewing.Wireframes')
          .then(() => {
            let ext = this.firstViewer.getExtension('Autodesk.Viewing.Wireframes')
            ext.linesMaterial.opacity = 1.0
            ext.activate()
          })
      }
      else {
        // console.log('extention loaded')
        if (ext.isActive()) {
          ext.deactivate()
        }
        else {
          ext.activate()
        }
      }
      this.firstViewer.setBackgroundColor(135, 206, 235, 255, 255, 255)
    }
  }

  accordionClick() {
    console.log('clicked on accordion !!')
    if (this.state.showStatistics) {
      this.setState({
        showStatistics: false
      })
    }
    else {
      this.setState({
        showStatistics: true
      })
    }
  }

  download(filename, url) {
    let element = document.createElement('a');
    element.setAttribute('href', url);
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);

    this.setState((state, props) => ({
      isDownloadDimmer: false
    }))
  }

  onReceiveUrl(responce) {
    fetch(responce.data)
      .then((res) => {
        // console.log("res: ", res)
        return res.blob();
      },
        (error) => {
          // console.log("error : ", error)
          this.setState((state, props) => ({
            isDownloadDimmer: false
          }))
        }
      )
      .then((result) => {
        // console.log("result : ", result)
        this.download(document.title.split("|")[0].trim() + ".zip", URL.createObjectURL(result));
      },
        (error) => {
          // console.log("error : ", error)
          this.setState((state, props) => ({
            isDownloadDimmer: false
          }))
        }
      )
  }

  downloadObjZip() {
    this.setState((state, props) => ({
      isDownloadDimmer: true
    }))

    let url = window.location.href.split("/")
    let sendData = {
      "action": "get-signed-url",
      "data": {
        "UID": url[url.length - 1]
      }
    }
    WebSocketClient.run(sendData, this.onReceiveUrl.bind(this));
  }

  getMenuBar() {

    let WireFrameMenuItem = <Popup trigger={
      <Menu.Item name='spam' onClick={this.wireframeShowOrHide.bind(this)}>
        <Icon name='pushed' />
      </Menu.Item>
    } content="Show/hide model wireframe" position='right center' />

    let downloadObjMenuItem = <Popup trigger={
      <Menu.Item name='spam' onClick={this.downloadObjZip.bind(this)}>
        <Icon name='download' />
      </Menu.Item>
    } content="Download result zip file" position='right center' />

    let facebookMenuItem = <Popup trigger={
      <Menu.Item name='spam'>
        <FacebookShareButton
          url={window.location.toString()}
          quote={'Segmentation'}>
          <Icon name='facebook f' />
        </FacebookShareButton>
      </Menu.Item>
    } content="Share on Facebook" position='right center' />

    let linkedinMenuItem = <Popup trigger={
      <Menu.Item name='spam'>
        <LinkedinShareButton
          url={window.location.toString()}>
          <Icon name='linkedin' />
        </LinkedinShareButton>
      </Menu.Item>
    } content="Share on LinkedIn" position='right center' />

    let twitterMenuItem = <Popup trigger={
      <Menu.Item name='spam'>
        <TwitterShareButton
          url={window.location.toString()}>
          <Icon name='twitter' />
        </TwitterShareButton>
      </Menu.Item>
    } content="Share on Twitter" position='right center' />

    return (
      <div className={styles['sideBarButton']}>
        <Menu color='blue' icon inverted vertical className={'material-shadow-20dp'}>
          <Route render={({ history }) => (
            <Popup
              trigger={
                <Menu.Item name='inbox' onClick={() => {
                  history.push('/')
                }}>
                  <Icon name='home' />
                </Menu.Item>
              }
              content="Close project"
              position='right center'
            />
          )} />

          {this.state.isStartingForgeViewer ? WireFrameMenuItem : null}
          {this.state.isStartingForgeViewer ? downloadObjMenuItem : null}
          {this.state.isStartingForgeViewer ? facebookMenuItem : null}
          {this.state.isStartingForgeViewer ? linkedinMenuItem : null}
          {this.state.isStartingForgeViewer ? twitterMenuItem : null}

        </Menu>
      </div>
    )
  }

  getColorCodingBar() {
    let tableRows = []
    for (let index = 0; index < this.state.statdata.labels.length; index++) {
      const element = this.state.statdata.labels[index];
      tableRows.push(
        (<tr key={this.state.statdata.labels[index]} style={{ marginBottom: '0.5rem' }}>
          <td style={{ "backgroundColor": this.state.geomColors[index], "padding": "1rem" }}></td>
          <td className={styles['colorLegendName']}>{element}</td>
        </tr>)
      )
    }

    return (
      <table className={this.state.showStatistics ? styles['colorLegendDivWhenStats'] : styles['colorLegendDivWhenNoStats']}>
        <tbody>
          {tableRows}
        </tbody>
      </table>
    )
  }

  getStatisticsComponent() {
    let predictionStatsEle = null

    if (this.state.showStatistics) {
      predictionStatsEle =
        <div className={styles['statistics']}>
          <Pie backgroundColor={'rgba(0, 0, 0, 0.1)'} data={this.state.statdata} options={this.state.statOptions} />
        </div>
    }

    let rootPanels = [
      { key: 'panel-1', title: 'Prediction statistics', content: { content: predictionStatsEle } }
    ]
    return (
      <div className={styles['statisticsDIV']} >
        <Accordion
          onTitleClick={this.accordionClick.bind(this)}
          className={styles['accordion']}
          defaultActiveIndex={0}
          panels={rootPanels} />
      </div>
    )
  }

  filesUpload() {
    this.recordPageView()
    this.elementTobeRendered = <FilesUpload></FilesUpload>
    return this.elementTobeRendered
  }

  home() {
    // Show page elements
    // let headerEle = document.getElementById("main_menu");
    let sendMsgEle = document.getElementById("send_message");
    let footerEle = document.getElementById("page_footer");
    let copyrightEle = document.getElementById("page_copyright");
    // let pageHeaderSec = document.getElementsByClassName("page_header_section");
    // headerEle.style.display = "flex";
    sendMsgEle.style.display = "flex";
    footerEle.style.display = "flex";
    copyrightEle.style.display = "flex";
    // Array.from(pageHeaderSec).forEach(item => {
    //   item.style.display = "flex";
    // })

    if (this.state.wsConnected) {
      this.elementTobeRendered = <SemanticCards changeHomePageState={this.changeHomePageState.bind(this)}
        webSocketClient={WebSocketClient}
        onClick={this.handleStartupSelection.bind(this)}
      ></SemanticCards>
    }

    return (
      this.elementTobeRendered
    );
  }

  gotoGeom(params) {
    // Hide page elements
    // let headerEle = document.getElementById("main_menu");
    let sendMsgEle = document.getElementById("send_message");
    let footerEle = document.getElementById("page_footer");
    let copyrightEle = document.getElementById("page_copyright");
    // let pageHeaderSec = document.getElementsByClassName("page_header_section");
    // headerEle.style.display = "none";
    sendMsgEle.style.display = "none";
    footerEle.style.display = "none";
    copyrightEle.style.display = "none";
    // Array.from(pageHeaderSec).forEach(item => {
    //   item.style.display = "none";
    // })

    if (this.state.wsConnected) {
      this.elementTobeRendered = <DualForgeViewer className={styles['dualForgeViewer']} webSocketClient={WebSocketClient}
        parentState={this.state}
        geomId={params.match.params.geomId}
        updateParentState={this.updateViewerState.bind(this)}
        OnFirstViewerLoaded={this.OnFirstViewerLoaded.bind(this)}
        OnDualViewerLoaded={this.OnDualViewerLoaded.bind(this)} ></DualForgeViewer>
    }
    return (
      this.elementTobeRendered
    );
  }

  gotoNewGeom(params) {
    // Hide page elements
    // let headerEle = document.getElementById("main_menu");
    let sendMsgEle = document.getElementById("send_message");
    let footerEle = document.getElementById("page_footer");
    let copyrightEle = document.getElementById("page_copyright");
    // let pageHeaderSec = document.getElementsByClassName("page_header_section");
    // headerEle.style.display = "none";
    sendMsgEle.style.display = "none";
    footerEle.style.display = "none";
    copyrightEle.style.display = "none";
    // Array.from(pageHeaderSec).forEach(item => {
    //   item.style.display = "none";
    // })

    if (this.state.wsConnected) {
      this.elementTobeRendered = <UploadSTL
        webSocketClient={WebSocketClient}
        updateParentState={this.updateCreateNewState.bind(this)}
        handleSegmentation={this.handleSegmentation.bind(this)}></UploadSTL>
    }
    return (
      this.elementTobeRendered
    );
  }

  render() {
    let isHomeButtonActive = false
    if (this.state.isStartingForgeViewer) {
      isHomeButtonActive = true
    }
    // console.log("this.state.isCreateNew : ", this.state.isCreateNew)

    return (
      <Provider store={store}>
        <Router basename={process.env.REACT_APP_URL_NAME}>
          <>
            <AppHeader />
            <div style={{ paddingTop: '80px' }}>
              {isHomeButtonActive ? this.getMenuBar() : null}
              <div>
                <Dimmer active={this.state.isDownloadDimmer} className={styles['dimmerStyle']}>
                  {<Loader>Please wait. Download will start soon.</Loader>}
                </Dimmer>
                {(this.state.isDualForgeViewerStarted && this.state.isGeomColorsAvailable && this.firstViewer) ? this.getStatisticsComponent() : null}
                {(this.state.isDualForgeViewerStarted && this.state.isGeomColorsAvailable && this.firstViewer) ? this.getColorCodingBar() : null}

                <Switch>
                  <Route exact path="/" render={this.home.bind(this)} />
                  <Route path="/geom/:geomId" render={this.gotoGeom.bind(this)} />
                  <Route path="/new" render={this.gotoNewGeom.bind(this)} />
                  <Route path="/filesUpload" render={this.filesUpload.bind(this)} />
                  <Redirect from="/*" to='/' />
                </Switch>
              </div>
            </div>
          </>
        </Router>
      </Provider>
    );
  }
}

export default App;